import { useParams } from 'react-router-dom';

import { useQuery } from 'src/core/api/hooks/useQuery';
import { type QueryState } from 'src/core/api/queryState';

import { type User } from '../../accounting';

type RawData = {
  users: User[];
};

type Result = User[];

export const useGetUsersWithoutEmployeeAccountQuery = (
  { isEnabled } = { isEnabled: true },
): QueryState<Result> => {
  const { company: companyId } = useParams();

  return useQuery<Result, RawData>({
    key: ['useGetUsersWithoutEmployeeAccountQuery', companyId],
    isEnabled,
    options: {
      cacheTime: 10 * 60 * 1000, // 10min,
      staleTime: 10 * 60 * 1000, // 10min,
    },
    request: {
      type: 'rest',
      target: 'companyAPI',
      endpoint: '/users/without-employee-account',
    },
    reshapeData(data) {
      return data.users;
    },
  });
};
